import css from "styled-jsx/css";

export default css`
    .bottom-seo{
        display: flex;
        flex-direction: column;
        margin-bottom: 5rem;
        :global(.carousel-slide .img-container) {
            height: 60%;
        }
        :global(.carousel-slide .product-slide-link) {
            width: 100% !important;
        }
        :global(.cms-detail-card-list .DetailCard .button-type--link) {
            padding: 0 !important;
        }
    }
`;
